import { createSlice } from '@reduxjs/toolkit'
const initialEditUserState = {
    loading: false,
    user: {
        name_tx: '',
        company_tx: '',
        email_tx: '',
        phone_tx: '',
        cell_tx: '',
        username_tx: '',
        hash_tx: '',
        role_id: '',
        ref_user_cd: '',
        address_tx: '',
        zip_tx: '',
        city_tx: '',
        state_tx: '',
        congregation: '',
        type: '',
        division_access: [],
        note_tx: '',
        billable_yn: '1',
        bill_type_tx: 'Auto', // Add bill_type_tx field with default 'Auto' for new users
        manual_device_count: '',
        user_login_count: 0,
    },
    userTypeOptions: [],
    congregationOption: [],
    states: [],
}

export const addUserSlice = createSlice({
    name: 'addUser',
    initialState: initialEditUserState,
    reducers: {
        updateAddUserState: (state, action) => {
            return { ...state, ...action?.payload }
        },
        setLoading: (state, action) => {
            state.loading = action.payload
        },
    },
})
export const { updateAddUserState, setLoading } = addUserSlice.actions
export default addUserSlice.reducer
